import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';
import { InputFieldDirectiveModule } from '../inputField/inputField';
import { TextareaFieldDirectiveModule } from '../textareaField/textareaField';
import { ResourceFieldCreateDirectiveModule } from './create/create';
import { ResourceFieldDetailDirectiveModule } from './detail/detail';
import { ResourceFieldEditDirectiveModule } from './edit/edit';

export const ResourceFieldDirectiveModule = angular
  .module('acme.common.directive.resourceField', [
    ResourceFieldEditDirectiveModule,
    ResourceFieldCreateDirectiveModule,
    ResourceFieldDetailDirectiveModule,
    InputFieldDirectiveModule,
    TextareaFieldDirectiveModule,
  ])
  .directive('resourceField', [
    function ResourceFieldDirective() {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/resourceField/resourceField.tpl.html',
        scope: {
          state: '@',
          field: '=',
          entity: '=',
          fieldIndex: '@fieldindex',
          resourceTemplateId: '@resourcetemplateid',
          disableEdit: '@disableedit',
        },
        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function ResourceFieldController($scope: IScope & { resourceField: TODO; disableEdit: TODO; state: TODO }) {
            $scope.resourceField = {
              init: function () {
                $scope.$on('resourceField::stateChange', this.onResourceFieldStateChange);
                $scope.$on('resourceField::remove', this.onResourceFieldRemove);
              },

              isEditEnabled: function () {
                // Normalize
                return $scope.disableEdit;
              },

              isInState: function (state) {
                return $scope.state === state;
              },

              onResourceFieldStateChange: function (e, data) {
                $scope.state = data.state;
              },

              onResourceFieldRemove: function (e, data) {
                // No handler necessary
              },
            };

            $scope.resourceField.init();
          },
        ],
      };
    },
  ]).name;
